import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of} from 'rxjs';
import {switchMap, map, catchError, withLatestFrom} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  loadCadModelRevisionValidationMessages,
  loadCadModelRevisionValidationMessagesFailure,
  loadCadModelRevisionValidationMessagesSuccess

} from "./cad-model-revision-message.action";

import {AppState} from "../../../shared/state/app.state";
import {CadModelService} from "../../data-access/cad-model.service";

import {selectCadModels} from "../cad-model/cad-model.selectors";


@Injectable()
export class CadModelRevisionMessageEffects {
  loadCadModelRevisionValidationMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCadModelRevisionValidationMessages),
      withLatestFrom(this.store.select(selectCadModels)),
      switchMap(([action, cadModels]) => {
          return this.cadModelService.getCadModelRevisionWithMessages(action.cadModelRevisionId)
            .pipe(
              map((response) => {
                return loadCadModelRevisionValidationMessagesSuccess({
                  cadModelRevisionMessage: {id: response.id, messages: response.validationMessages}
                });
              }),
              catchError((response) => of(loadCadModelRevisionValidationMessagesFailure(
                {
                  error: response
                }
              )))
            )
        }
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private cadModelService: CadModelService,
  ) {}
}
